import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 mb-4">
            <i className="ri-survey-line text-primary-600 text-sm"></i>
            <span className="text-primary-700 text-xs font-medium">深度揭秘</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            黑料揭秘
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            独家调查报道，直击事件核心，还原真实内幕
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1.5 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-background-950/60 backdrop-blur-sm text-background-50 text-xs font-medium">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-3 mb-4">
                  {item.description}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-200">
                  <span className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-eye-line"></i>
                    {item.reads} 阅读
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-chat-1-line"></i>
                    {item.comments.toLocaleString()} 评论
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}